import React from 'react';
import Card from 'react-bootstrap/Card';
import styles from './MemberRegistration.css';
export default function SwaggerReference(){
return (
<div className="container">
<Card className="card-background"> <Card.Body>
<blockquote className="blockquote mb-0">
<h1 className="text-header">Swagger Reference</h1>

</blockquote>
</Card.Body>
</Card>
<hr className="horizontal-rule"></hr>
<br/>
<Card className="card-background"> <Card.Body>
<p>
Swagger allows you to describe the structure of your APIs so that machines can read them. The ability of APIs to describe their own structure is the root of all awesomeness in Swagger. Why is it so great? Well, by reading your API’s structure, we can automatically build beautiful and interactive API documentation. We can also automatically generate client libraries for your API in many languages and explore other possibilities like automated testing. Swagger does this by asking your API to return a YAML or JSON that contains a detailed description of your entire API. This file is essentially a resource listing of your API which adheres to OpenAPI Specification.</p>
<p> The specification asks you to include information like:</p>
<ul>
<li>What are all the operations that your API supports?</li>
<li>What are your API’s parameters and what does it return?</li>
<li>Does your API need some authorization?</li>
<li>And even fun things like terms, contact information and license to use the API.</li>
</ul>
<br></br>
You can also test our API's through Swagger: <a href={`${process.env.REACT_APP_EDUCATIONAL_MATERIAL_URL}api-docs`} target='new'>Click here</a>.
</Card.Body>
</Card>
</div>
);
}